import Vue from "vue";
import VueRouter from "vue-router";
import sCache from "@/plugins/simple-cache";
import store from "../store/index";

Vue.use(VueRouter);
Vue.use(sCache, { store });
/**
 * Setting the current logged in user.
 */

const router = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      // route level code-splitting
      // this generates a separate chunk (home.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "home" */ "../views/Home.vue"),
      meta: {},
    },
    {
      path: "/scpermit",
      name: "scpermit",
      // route level code-splitting
      // this generates a separate chunk (scpermit.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "scpermit" */ "../views/SCPermit.vue"),
      meta: {},
    },
    {
      path: "/scescrow",
      name: "scescrow",
      // route level code-splitting
      // this generates a separate chunk (scescrow.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "scescrow" */ "../views/SCEscrow.vue"),
      meta: {},
    },
    {
      path: "/payment",
      name: "payment",
      // route level code-splitting
      // this generates a separate chunk (payment.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "payment" */ "../views/Payment.vue"),
      meta: {},
      params: true,
    },
    {
      path: "/success",
      name: "success",
      // route level code-splitting
      // this generates a separate chunk (success.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "success" */ "../views/Success.vue"),
      meta: {},
      params: true,
    },
    {
      path: "/dasantenna",
      name: "dasantenna",
      // route level code-splitting
      // this generates a separate chunk (dasantenna.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "dasantenna" */ "../views/DasAntenna.vue"),
      meta: {},
    },
    {
      path: "/gpis",
      name: "gpis",
      // route level code-splitting
      // this generates a separate chunk (gpis.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "gpis" */ "../views/Gpis.vue"),
      meta: {},
    },
    {
      path: "/error",
      name: "error",
      // route level code-splitting
      // this generates a separate chunk (error.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "error" */ "../views/Error.vue"),
      meta: {},
    },
    {
      path: "*",
      name: "notfound",
      component: () =>
        import(/* webpackChunkName: "notfound" */ "../views/NotFound.vue"),
      meta: {
        requiresAuth: false,
      },
    },
  ],
});

export default router;
